/**
 * CollapsibleSection - Expandable section with header toggle
 *
 * Reusable collapsible container with chevron animation.
 */

import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

interface CollapsibleSectionProps {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  className?: string;
}

export function CollapsibleSection({
  title,
  isOpen,
  onToggle,
  children,
  className = '',
}: CollapsibleSectionProps) {
  return (
    <div className={`pt-2 border-t border-gray-300 mt-2 ${className}`}>
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between mb-2 hover:bg-gray-50 px-2 py-1 rounded transition-colors"
      >
        <span className="text-sm font-semibold text-gray-700">{title}</span>
        {isOpen ? (
          <ChevronUp className="h-4 w-4 text-gray-500" />
        ) : (
          <ChevronDown className="h-4 w-4 text-gray-500" />
        )}
      </button>
      {isOpen && children}
    </div>
  );
}

export default CollapsibleSection;
